import { LiveBackgroundContext } from "./components/liveBackground/LiveBackground";
import LiveAudio from "./components/liveAudio/LiveAudio";
import Live2MCPage from "./views/live2/mc";
import LiveV2MTPage from "./views/live2/mt";
import LiveV2TNPage from "./views/live2/tn";
import LiveV2TNBlackPage from "./views/live2/tn-black";
import Live2LeapPage from "./views/live2/leap";
import Live2SCPage from "./views/live2/sc";
import Live2KHPage from "./views/live2/kh";
import Live2KPPage from "./views/live2/kp";
import Live2TN830Page from "./views/live2/tn-minhngoc";
import Live2MCBlackPage from "./views/live2/mc-black";
import Live3TNPage from "./views/live3/tn";
import Live3TN830Page from "./views/live3/tn-minhngoc";
import Live3MTPage from "./views/live3/mt";
import Live3MCPage from "./views/live3/mc";
import Live3LeapPage from "./views/live3/leap";
import Live3SCPage from "./views/live3/sc";
import Live3KHPage from "./views/live3/kh";
import Live2TNBlack830Page from "./views/live2/tn-minhngoc-black";

const routes = [
    {
        exact: true,
        path: "live-v2/mt",
        name: "MT",
        element: <LiveV2MTPage />
    },
    {
        exact: true,
        path: "/live-v2/tc",
        name: "TC",
        element: <LiveV2TNPage />
    },

    {
        exact: true,
        path: "/live-v2/tc_minhngoc",
        name: "TC-Minhngoc",
        element: <Live2TN830Page />
    },

    {
        exact: true,
        path: "/live-v2/mc",
        name: "MC",
        element: <Live2MCPage />
    },

    {
        exact: true,
        path: "/live-v2/leap",
        name: "LEAP",
        element: <Live2LeapPage />
    },
    {
        exact: true,
        path: "/live-v2/sc",
        name: "SC",
        element: <Live2SCPage />
    },
    {
        exact: true,
        path: "/live-v2/kh",
        name: "KH",
        element: <Live2KHPage />
    },
    {
        exact: true,
        path: "/live-v2/kp",
        name: "KP",
        element: <Live2KPPage />
    }
]

const routesBlack = [
    {
        exact: true,
        path: "/live-v2/mc-black",
        name: "MC Black",
        element: <Live2MCBlackPage />
    },
    {
        exact: true,
        path: "/live-v2/tc-black",
        name: "TC Black",
        element: <LiveV2TNBlackPage />
    },
    {
        exact: true,
        path: "/live-v2/tc_minhngoc-black",
        name: "TC-Minhngoc Black",
        element: <Live2TNBlack830Page />
    }
]

const routesV3 = [
    {
        exact: true,
        path: "/live-v3/mt",
        name: "MT",
        element: <Live3MTPage />
    },
    {
        exact: true,
        path: "/live-v3/mc",
        name: "MC",
        element: <Live3MCPage />
    },
    {
        exact: true,
        path: "/live-v3/tc",
        name: "TC",
        element: <Live3TNPage />
    },
    {
        exact: true,
        path: "/live-v3/tc_minhngoc",
        name: "TC-Minhngoc",
        element: <Live3TN830Page />
    },
    {
        exact: true,
        path: "/live-v3/leap",
        name: "LEAP",
        element: <Live3LeapPage />
    },
    {
        exact: true,
        path: "/live-v3/sc",
        name: "SC",
        element: <Live3SCPage />
    },
    {
        exact: true,
        path: "/live-v3/kh",
        name: "KH",
        element: <Live3KHPage />
    },
    {
        exact: true,
        path: "/live-v3/kp",
        name: "KP",
        element: <Live2KPPage />
    },
]

const routesFull = routes.map((route) => ({
    ...route,
    path: `/live-full/${route.path.split("/").pop()}`,
    element: <LiveBackgroundContext.Provider value={route.path.split("/").pop()}>
        <LiveAudio>{route.element}</LiveAudio>
    </LiveBackgroundContext.Provider>,
}));

const routesV4 = routesV3.map((route) => ({
    ...route,
    path: `/live-v4/${route.path.split("/").pop()}`,
    element: <LiveBackgroundContext.Provider value={route.path.split("/").pop()}>
        <LiveAudio>{route.element}</LiveAudio>
    </LiveBackgroundContext.Provider>,
}));

export { routes, routesBlack, routesV3, routesFull, routesV4 }
